<template>
  <div class="field-wrapper p-4">
    <label :for="id" class="text-sm px-2">{{ label }}</label>
    <input class="w-full text-left px-2" :disabled='disabled' @change='handleFile' type="file" :name="name" :id="id" accept=".pdf, image/*"/>
  </div>
</template>

<script>
export default {
    props: ['name', 'id', 'label',  'value', 'disabled'],
    data() {
        return {
            file: null,
        }
    },
    methods: {
        handleFile(event) {
            this.file = event.target.files[0];
        }
    },
    watch: {
        file(val) {
            this.$emit('input', val);
        }
    }
}
</script>

<style lang="scss" scoped>
  .field-wrapper {
    display: block;
    overflow: hidden;
    label {
      display: block;
      text-align: left;
      font-weight: 600;
      text-transform: uppercase;
    }
  }
</style>
